// extracted by mini-css-extract-plugin
export default {"mainContainer":"Event_mainContainer__C2wse","upperWrapper":"Event_upperWrapper__q83Hm","bottomWrapper":"Event_bottomWrapper__KxFZH"};